module.exports = __webpack_public_path__ + "static/img/greytabbt.dae2579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/greytabbt.png
// module id = qRem
// module chunks = 1